<template>
    <main-content with_go_back_bar>
        <add-group :action="addGroup"></add-group>
        <groups-filter :action="filterAction"></groups-filter>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </main-content>
</template>

<script>

import MainContent from "@/components/main-content";
import toastr from "toastr";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {ApiUrl, userService} from "@/common/api.service";
import {i18n} from "@/plugins/i18n";
import addGroup from "@/views/user-categories/components/add-group";
import GroupsFilter from "@/views/user-categories/components/filter-groups";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "@/views/user-categories/datatable/groups-columns";
import actionsColumn from "@/views/user-categories/components/groups-actions-column";

export default {
    components: {
        MainContent,
        'add-group': addGroup,
        'groups-filter': GroupsFilter,
    },
    data() {
        return {
            query: {}
        }
    },
    computed:{
        datatableProps() {
            return {
                id: "groups_datatable",
                data: {
                    type: "remote",
                    source: {
                        read: {
                            url: ApiUrl.path("user/groups/" + this.$route.params.cat_id),
                            method: "GET",
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data;
                            },
                            params: {
                                query: this.query,
                            }
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn,
            };
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
            }

            return toastr
        }
    },
    methods: {
        filterAction(e, query) {
            this.query = query;
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },
        addGroup(e, params) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                ignore: ":hidden",

                rules: {
                    group_name : {
                        required: true,
                    }
                },
            });

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)
            userService.addGroup(this.$route.params.cat_id, params)
                .then(response => {
                    this.toastr.success(response.data.message)
                })
                .catch(({response}) => {
                    this.toastr.error(i18n.t('message.an_error_accord'))
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                    if (this.$refs.datatable.KTDatatable) {
                        this.$refs.datatable.reload();
                    }
                })
        }
    }
}
</script>